<template>
  <div class="container presentation-container">
    <div style="padding: 50px">

      <div class="row">
        <div class="col-md-auto text-center">
          <img src="../../../public/assets/images/OREP_EO_logo.png" height="88" width="220" alt="Logo">
        </div>
        <div class="col-md-7 text-center">
          <p class="comic-font-extra-bold" style="font-size: 28px;">
            <span>
              <strong>Home Inspector’s</strong>
            </span>
            <span class="comic-font-semi-bold">
             Professional Liability
          </span>
          </p>
          <p class="comic-font-extra-bold" style="font-size: 15px; color: #05689a">
            Errors & Omissions & General Liability/Coverage
          </p>

        </div>
        <div class="col-md-auto text-center">
          <img src="../../../public/assets/images/20_year_medallion.png" height="88" width="88" alt="18 years">
        </div>
      </div>
      <hr class="new1">
      <div class="col text-center" style="padding-top: 5px;">
        <p class="comic-font-extra-bold" style="font-size: 30px; color: #05689a">
          PREMIUM PROPOSAL
        </p>
      </div>
      <div class="col text-center">
        <p class="comic-font-extra-bold" style="font-size: 20px; color: black">
          PREPARED FOR:
        </p>
      </div>
      <div class="col text-center" style="padding-bottom: 5px">
        <p class="comic-font-bold" style="font-size: 20px; color: #05689a"><u>
          {{ quote.nameOfPrincipalHomeInspector }}
        </u>

        </p>
      </div>

      <hr class="new1" >

      <div class="row">
        <div class="col-md-7 col-sm-12" style="background-color: lightgrey;padding: 30px">
          <div class="form-group row">
            <label for="staticBusiness" class="col-sm-3 col-form-label comic-font-bold" style="font-size: 16px; color: #05689a" >BUSINESS:</label>
            <div class="col-sm-9">
              <input type="text" readonly class="form-control" id="staticBusiness" :value=quote.fullLegalNameOfApplicant>
            </div>
          </div>
          <div class="form-group row">
            <label for="staticAddress" class="col-sm-3 col-form-label comic-font-bold" style="font-size: 16px; color: #05689a" >ADDRESS:</label>
            <div class="col-sm-9">
              <input type="text" readonly class="form-control" id="staticAddress"  :value=quote.customer.address>
            </div>
          </div>
          <div class="form-group row">
            <label for="staticCity" class="col-sm-3 col-form-label comic-font-bold" style="font-size: 16px; color: #05689a" >CITY:</label>
            <div class="col-sm-9">
              <input type="text" readonly class="form-control" id="staticCity" :value=quote.customer.city>
            </div>
          </div>
          <div class="form-group row">
            <label for="staticState" class="col-sm-3 col-form-label comic-font-bold" style="font-size: 16px; color: #05689a" >STATE:</label>
            <div class="col-sm-9">
              <input type="text" readonly class="form-control" id="staticState" :value=statesName>
            </div>
          </div>
          <div class="form-group row">
            <label for="staticZipCode" class="col-sm-3 col-form-label comic-font-bold" style="font-size: 16px; color: #05689a" >ZIP CODE:</label>
            <div class="col-sm-9">
              <input type="text" readonly class="form-control" id="staticZipCode" :value=quote.customer.zipCode>
            </div>
          </div>
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-3 col-form-label comic-font-bold" style="font-size: 16px; color: #05689a" >EMAIL:</label>
            <div class="col-sm-9">
              <input type="text" readonly class="form-control" id="staticEmail" :value=quote.customer.email>
            </div>
          </div>
          <div class="form-group row">
            <label for="staticPhone" class="col-sm-3 col-form-label comic-font-bold" style="font-size: 16px; color: #05689a" >PHONE:</label>
            <div class="col-sm-9">
              <input type="text" readonly class="form-control" id="staticPhone" :value=quote.customer.phone>
            </div>
          </div>
        </div>
        <div class="col-md-5 col-sm-12" style="background-color: lightgrey;padding-left: 0px;padding-right: 0px;">
          <img src="../../../public/assets/images/inspector-proposal.jpg" height="100%" width="100%" alt="Inspector Proposal">
        </div>
      </div>
      <div v-if="isShowingRate" class="col text-center" style="padding-top: 20px;">
        <p class="comic-font-extra-bold" style="font-size: 30px; color: #05689a">
          SELECT YOUR COVERAGE
        </p>
      </div>
      <div v-if="!isShowingRate" class="col text-left" style="margin-top: 20px">
        <p class="comic-font-bold" style="font-size: 20px; color: black">
          Thank you for submitting your application. Based on one or more answers, your application will need to be reviewed by an underwriter before we can present you with a premium proposal.
          Someone from OREP will reach out to you via email or phone within two business days. Thank you for shopping OREP!
        </p>
      </div>

      <div v-if="isShowingRate" class="col text-center">
        <p class="comic-font-extra-bold" style="font-size: 25px; color: black">
          Please sign the Proposal Below to Proceed.
        </p>
      </div>
      <div v-if="isShowingRate" class="col text-center">
        <p class="comic-font-extra-bold" style="font-size: 15px; color: black">
          Scroll down to review and sign your Premium Proposal.
        </p>
        <p v-if="isShowingRate" class="comic-font-extra-bold" style="font-size: 15px; color: black">
          Financing option included on the next page.
        </p>
      </div>
      <div v-if="isShowingRate" class="col text-center" style="padding-top: 10px">
        <img src="../../../public/assets/images/arrow.png" alt="Arrow Down">
      </div>
      <hr class="new1" />
      <div v-for="(coverage, index) in coverages" class="mb-4 orep-price" :key="index" v-if="isShowingRate">
      <div class="col text-center" style="background-color:  #05689a;margin-top: 40px;">
        <p class="comic-font-extra-bold" style="font-size: 25px; color: white">
          LIMITS - {{ coverage.limitOfCoverage }}
        </p>
      </div>
      <div class="row" style="margin-top: 40px">
        <div class="col-md-2 text-right">
          <div>
            <input
              type="radio"
              name="coverage"
              :value="index"
              class="orep-radio position-relative comic-font-extra-bold"
              checked="index==0"
              v-model="quote.coverage"
            >
          </div>
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font-bold" style="font-size: 18px;">{{ coverage.limitOfCoverage }} E&O/GL Insurance Policy
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font" style="font-size: 18px;">{{ coverage.orepClaim }} Personal Injury Coverage
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font" style="font-size: 18px;">{{ coverage.orepClaim }} General Liability Coverage (Per Claim)
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font" style="font-size: 18px;">{{ coverage.orepClaim }} Professional Liability – Each Claim Limit
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font" style="font-size: 18px;">{{ coverage.orepAggregate }} Professional Liability – Aggregate Limit
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font" style="font-size: 18px;">$25,000 Disciplinary Proceedings
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font" style="font-size: 18px;">$5,000 Loss of Earnings
          </p>
        </div>
      </div>

      <div class="row" style="margin-top: 50px">
        <div class="col-md-3 text-center">
        </div>
        <div class="col-md-6 text-left">
          <div class="form-group row">
            <label for="staticPremium" class="col-md-6 col-form-label comic-font-extra-bold" style="font-size: 16px; color: #05689a" >E&O/GL PREMIUM:</label>
            <div class="col-md-6">
              <input v-if="quote.cyberCoverage" type="text" readonly class="form-control comic-font-extra-bold" id="staticPremium" :value=coverage.cyberPremium >
              <input v-else type="text" readonly class="form-control comic-font-extra-bold" id="staticPremium" :value=coverage.premium >
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-center">
        </div>
        <div class="col-md-6 text-left">
          <div class="form-group row">
            <label for="surplusLineTax" class="col-md-6 col-form-label comic-font" style="font-size: 16px; color: #05689a" >{{ quote.customer.state }} SL TAX:</label>
            <div class="col-md-6">
              <input type="text" v-if="quote.cyberCoverage" readonly class="form-control" id="surplusLineTax" :value=coverage.cyberSurplusLineTax >
              <input type="text"  v-else readonly class="form-control" id="surplusLineTax" :value= coverage.surplusLineTax >
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3 text-center">
        </div>
        <div class="col-md-6 text-left">
          <div class="form-group row">
            <label for="stampingFee" class="col-md-6 col-form-label comic-font" style="font-size: 16px; color: #05689a" >{{ quote.customer.state }} SL STAMPING FEE:</label>
            <div class="col-md-6">
              <input type="text" v-if="quote.cyberCoverage" readonly class="form-control" id="stampingFee" :value=coverage.cyberStampingFee >
              <input type="text"  v-else readonly class="form-control" id="stampingFee" :value=coverage.stampingFee >
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3 text-center">
        </div>
        <div class="col-md-6 text-left">
          <div class="form-group row">
            <label for="orepFee" class="col-md-6 col-form-label comic-font" style="font-size: 16px; color: #05689a" >OREP MEMBER FEE:</label>
            <div class="col-md-6">
              <input type="text" readonly class="form-control" id="orepFee" :value=coverage.orepFee >
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3 text-center">
        </div>
        <div class="col-md-6 text-left">
          <div class="form-group row">
            <label for="extraFee" class="col-md-6 col-form-label comic-font" style="font-size: 16px; color: #05689a" >ADDITIONAL STATE FEE:</label>
            <div class="col-md-6">
              <input v-if="quote.cyberCoverage" type="text" readonly class="form-control" id="extraFee" :value=coverage.cyberExtraFee >
              <input v-else type="text" readonly class="form-control" id="extraFee" :value=coverage.extraFee >
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3 text-center">
        </div>
        <div class="col-md-6 text-left">
          <div class="form-group row">
            <label for="total" class="col-md-6 col-form-label comic-font-extra-bold" style="font-size: 16px; color: #05689a" >TOTAL DUE:</label>
            <div class="col-md-6">
              <input type="text"  v-if="quote.cyberCoverage" readonly class="form-control comic-font-extra-bold" id="total" :value=coverage.cyberTotal>
              <input type="text"  v-else readonly class="form-control comic-font-extra-bold" id="total" :value=coverage.total>
            </div>
          </div>
        </div>
      </div>

    </div>
<!--      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a" v-if="isShowingRate">-->
<!--        <p class="comic-font-bold" style="font-size: 25px; color: white">-->
<!--          OPTIONAL - CYBER COVERAGE-->
<!--        </p>-->
<!--      </div>-->
<!--      <div class="row" style="margin-top: 30px" v-if="isShowingRate">-->
<!--        <div class="col-md-2 text-center">-->
<!--        </div>-->
<!--        <div class="col-md-8 text-left">-->
<!--          <div class="form-check">-->
<!--            <input type="checkbox" class="form-check-input" id="exampleCheck1"-->
<!--                   name="cyberCoverage"-->
<!--                   value-->
<!--                   v-model="quote.cyberCoverage" >-->
<!--            <label class="form-check-label comic-font-bold" for="exampleCheck1">$50,000 Cyber Coverage for $59</label>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="row"  v-if="isShowingRate">-->
<!--        <div class="col-md-2 text-center">-->
<!--        </div>-->
<!--        <div class="col-md-8 text-left">-->
<!--          <div class="form-check">-->
<!--            <p class="form-check-label comic-font">-->
<!--              <i>-->
<!--                If selected, Totals listed above will automatically update.-->
<!--              </i>-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          *INCLUDED COVERAGES  No Additional Premium
        </p>
      </div>
      <div class="row" style="margin-top: 20px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-5 text-left">
          <div>
            <ul>
              <li class="comic-font" style="font-size: 18px; color: black" >Limited Additional Insured–Referring Party</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Infrared Thermography</li>

              <li class="comic-font" style="font-size: 18px; color: black" >Disciplinary Coverage</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Commercial</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Termite Inspections</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Pool and Spa Inspections</li>
              <li class="comic-font" style="font-size: 18px; color: black" >EIFS Inspections</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Lead Inspections</li>


            </ul>
          </div>
        </div>
        <div class="col-md-4 text-left">
          <div>
            <ul>
              <li class="comic-font" style="font-size: 18px; color: black" >Wind Mitigation Testing</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Rodent Inspections</li>

              <li class="comic-font" style="font-size: 18px; color: black" >Disciplinary Coverage</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Drone</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Green Building Inspections</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Indoor Air Quality Testing</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Carbon Monoxide Testing</li>
              <li class="comic-font" style="font-size: 18px; color: black" >Radon Testing Inspections</li>


            </ul>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 20px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <div>
            <p class="comic-font" style="font-size: 17px; color: black"><i>
              *Sub limits apply to certain coverages, please ask your OREP agent for details.
              Coverages require training, experience, or certification.</i>
            </p>
          </div>
        </div>
      </div>

      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          OREP Program Highlights & Additional Professional Support
        </p>
      </div>
      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <div class="row">
            <div class="col-md-auto text-center">
              <img src="../../../public/assets/images/OREP_EO_logo.png" height="88" width="220px" alt="Logo">
            </div>
            <div class="col-md-auto text-center">
              <img src="../../../public/assets/images/20_year_medallion.png" height="88" width="88" alt="18 years">
            </div>
            <div class="col-md-5 text-left">
              <p class="comic-font-extra-bold" style="font-size: 21px;">
                Serving Home Inspector’s
                E&O Insurance Needs
                over 20 Years
              </p>
            </div>

          </div>
          <hr class="new1">
        </div>

      </div>
      <div class="row" style="margin-top: 20px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-5 text-left">
          <div>


            <p class="comic-font-extra-bold" style="font-size: 18px; color: black">
              Coverage is Non-Admitted,  “A” Rated Carrier
            </p>
          </div>
          <br />
          <div>
            <p class="comic-font-extra-bold" style="font-size: 18px; color: black">
              Free Risk Management and
              Free Pre-Claims Assistance
            </p>
          </div>
          <br />
          <div>
            <p class="comic-font-extra-bold" style="font-size: 18px; color: black">
              Additional Insured for Agents and
              other Referring Parties and Franchisors
            </p>
          </div>
          <br />
          <div>
            <p class="comic-font-extra-bold" style="font-size: 18px; color: black">
              Includes Personal Injury, Loss of
              Earnings, and Board Complaint/
              Disciplinary Coverage
            </p>
          </div>
          <br />
          <div>
            <p class="comic-font-extra-bold" style="font-size: 18px; color: black">
              Easy Financing
            </p>
          </div>
          <br />
          <div>
            <p class="comic-font" style="font-size: 18px; color: black">
                        <span class="comic-font-extra-bold">
                             <strong>Corporate Savings:</strong>
              </span>
               cell phone plans,
              office supplies, car rentals, and many
              other goods and services.
            </p>
          </div>

        </div>
        <div class="col-md-4 text-left">
          <div>
            <p class="comic-font" style="font-size: 18px; color: black">
                            <span class="comic-font-extra-bold">
                             <strong>OREP Risk Management/Business
                Support Benefits:</strong>
              </span>
               including free
              on-demand inspection support at
              InspectorAdvisor.com, savings on
              attorney-approved professional
              service contracts, discounted
              120-Day Warranty pricing to increase
              your business, discounted education
              and Working RE Inspector’s Journal.
            </p>
          </div>
          <br />
          <div>
            <p class="comic-font" style="font-size: 18px; color: black">
              <span class="comic-font-extra-bold">
                             <strong>Enjoy Free Training through AAAHI on
                a variety of core inspection skills:</strong>
              </span>
              including Electrical, Plumbing,
              Foundation/Structure, HVAC, Multi-Unit/
              Apartment Inspections, Mold, Radon,
              Drones, and much more!
            </p>
          </div>
        </div>
      </div>
      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          PROPOSAL SUBJECTIVITIES
        </p>
      </div>

      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <p class="comic-font-extra-bold" style="font-size: 18px;">The following will be required prior to policy issuance:
          </p>
        </div>

      </div>
      <div class="row">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <p class="comic-font" style="font-size: 18px;"  v-if="!this.state.signedInUser" >             <span>
    <i class="fa fa-check-square" aria-hidden="true"></i></span>
            Copy of Inspection Agreement
          </p>
          <p class="comic-font" style="font-size: 18px;"  v-if="quote.moldTesting" >             <span>
    <i class="fa fa-check-square" aria-hidden="true"></i></span>
            Copy of Mold Training Certificate
          </p>
          <p class="comic-font" style="font-size: 18px;" v-if="quote.septicWaterTestingSewerScoping"  >             <span>
    <i class="fa fa-check-square" aria-hidden="true"></i></span>
            Copy of Septic/Water Testing Training Certificate
          </p>
          <p class="comic-font" style="font-size: 18px;" v-if="quote.isFirmCurrentlyInsured === 'true'" >   <span>
    <i class="fa fa-check-square" aria-hidden="true"></i></span> Current E&O Insurance Declarations Page (if applicable)
          </p>
          <p class="comic-font" style="font-size: 18px;" >   <span>
    <i class="fa fa-check-square" aria-hidden="true"></i></span> Inspector agrees to take continuing education and/or training yearly or as required by their state licensing authority.


          </p>
        </div>


      </div>
      <div class="row">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <p class="comic-font" style="font-size: 17px;">Premium/taxes subject to change based on additional underwriting information that
            may be required.<strong> ACCEPTANCE OF PAYMENT BY OREP DOES NOT CONSTITUTE COVERAGE.
              COVERAGE IS NOT BOUND UNTIL RECEIPT OF YOUR CERTIFICATE OF INSURANCE.</strong>
          </p>
        </div>


      </div>

      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a" v-if="isShowingRate" >
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          COMPLETE YOUR COVERAGE
        </p>
      </div>
      <div class="row" style="margin-top: 30px" v-if="isShowingRate" >
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p  style="font-size: 18px;">
            <span class="comic-font-extra-bold">
             <strong>1. To accept the quote and terms</strong>
            </span>
            <span class="comic-font"> listed here, please type your name in the Signature Block below and hit “SUBMIT.”
            </span>

          </p>
        </div>


      </div>
      <div class="row" v-if="isShowingRate" >
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font" style="font-size: 18px;">
           <span class="comic-font-extra-bold">
             <strong>2. Make your Payment or Down Payment</strong></span><span> (if financing), at our secure Checkout
            on the next page. Low Down Payment Financing is available on Next Page.

          </span>
          </p>
        </div>


      </div>
      <div class="row" style="margin-bottom: 100px;" v-if="isShowingRate" >
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font" style="font-size: 18px;">
                       <span class="comic-font-extra-bold">
                         <strong>Questions before submitting payment?</strong></span>
            <br /><span>
            Please email inspectors@orep.org or for immediate assistance during office hours,
            call 888-347-5273. (9-8 EST and 6-5 PST.)</span>
          </p>
        </div>


      </div>

      <div class="form-group row text-center" style="margin-top: 40px;" v-if="isShowingRate">
        <div class="col-md-2 text-center">
        </div>
        <label for="quoteSignature" class="col-sm-3 col-form-label comic-font-extra-bold" style="font-size: 28px; color: black" >SIGNATURE: </label>
        <div class="col-md-6">
          <input type="text" style="font-size: 28px; color: black" class="form-control comic-font-extra-bold" id="quoteSignature"
                 name="quoteSignature"
                 v-validate="'required'"
                 @input="validateBeforeSubmit()"
                 v-model="quote.quoteSignature"
                 placeholder="Type Your Name to Sign">
          <span
            v-show="errors.has('quoteSignature')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('quoteSignature') | filterText }}</span>

        </div>
      </div>
      <div v-if="isShowingRate" class="form-group row text-center" style="margin-top: 40px;margin-bottom: 40px">
        <div class="col-md-2 text-center">
        </div>
        <label for="staticDate" class="col-sm-3 col-form-label comic-font-extra-bold" style="font-size: 28px; color: black" >DATE: </label>
        <div class="col-md-6">
          <input type="text" style="font-size: 28px; color: black" readonly class="form-control comic-font-extra-bold" id="staticDate"
                 :value="formattedCurrentDate()"
                 disabled placeholder="Todays Date">
        </div>

      </div>

      <div v-if="isShowingRate" class="form-group row text-center" style="margin-top: 40px;margin-bottom: 100px" >
        <div class="col">
          <button
            class="rounded-pill text-uppercase text-center comic-font-bold rounded-pill" style="padding: 20px;background-color: #05689a;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
            @click="formSubmit()"
            :disabled="!state.pagefinalIsValid"
            :class="{submitDisabled: !state.pagefinalIsValid}"
            v-if="isShowingRate"
          >Submit</button>
        </div>

      </div>
      <div v-if="isShowingRate" class="row">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font" style="font-size: 18px;">Premium/taxes subject to change based on additional underwriting information that
            may be required.<strong> ACCEPTANCE OF PAYMENT BY OREP DOES NOT CONSTITUTE COVERAGE.
              COVERAGE IS NOT BOUND UNTIL RECEIPT OF YOUR CERTIFICATE OF INSURANCE.</strong>
          </p>
        </div>


      </div>

      <div v-if="!!loading"
           class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
           style="opacity: 0.7; top: 0; left: 0;">
        <span class="text-white" style="font-size: 16px">Processing...</span>
      </div>

      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-8 text-left">
          <p class="comic-font-bold" style="font-size: 18px;">
            <strong>Thank you<br/>
              Team OREP.</strong>
          </p>
        </div>


      </div>
    </div>


    <footer style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <img src="../../../public/assets/images/white-logo.png" width="220px" alt="Logo">
        </div>
        <div class="col-md-8 col-sm-12">
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP Insurance Services, LLC California License #0K99465
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            6353 El Cajon Blvd, Suite 124-605
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            San Diego, CA 92115
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (888) 347-5273
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            inspectors@OREP.org
          </p>
        </div>
      </div>

    </footer>
  </div>

</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import {APP_STATUS, STATES, STATUS} from '../../utils/constants';

export default {
  name: 'home-inspector-final',
  data() {
    return {
      loading: false,
    };
  },
  computed: {

    state() {
      return this.$store.state.homeInspector;
    },
    quote() {
      return this.$store.state.homeInspector.quote;
    },
    coverages() {
      return this.$store.state.homeInspector.coverages;
    },
    statesName() {
      return STATES[this.$store.state.homeInspector.quote.customer.state];
    },
    isShowingRate() {
      return !(this.$store.getters['homeInspector/totalRevenueOfInspectionsInThisYear'] > 150000 ||
          this.$store.getters['homeInspector/totalRevenueOfInspectionsInNextYear'] > 150000 ||
          this.quote.licensedInWorkingStates === 'no' ||
          this.quote.haveYourExperiencedBankruptcyInLast7Years === 'true' ||
          this.quote.complianceInspections === 'true' ||
          this.quote.involvedInAuctionOfPersonalProperty === 'true' ||
          this.quote.performInspectionsOnOwnProperty === 'true' ||
          this.quote.providesRepairWorkOnInspectedProperty === 'true' ||
          this.quote.doYouUseIndependentContractors === 'true' ||
          Number(this.quote.homeInspectorsFullTime) + Number(this.quote.homeInspectorsPartTime) > 2 ||
          this.quote.knowledgeOfActEoPotentialClaimFuture === 'true' ||
          this.quote.hasBeenSubjectToEoClaimPast === 'true' ||
          this.quote.criticizedCensoredSuspendedRevoked === 'true' ||
          this.quote.insuranceDeniedCancelledNonrenewedInsurance === 'true' ||
          this.quote.applicantExclusiveToAnyCompany === 'true' ||
          this.quote.isThereAMethodToAuthenticatePhotoDatetime === 'false' ||
          this.quote.commercialInspectionsOnPropertyOver1000SqFeet === 'true' ||
          Number(this.quote.percentHotels) > 0 ||
          Number(this.quote.percentLightIndustrial) > 0 ||
          Number(this.quote.percentRestaurants) > 0 ||
          Number(this.quote.percentChurches) > 0 ||
          Number(this.quote.percentMunicipal) > 0 ||
          Number(this.quote.percentHeavyIndustrial) > 0 ||
          Number(this.quote.percentMixedUse) > 0 ||
          Number(this.quote.percentOther) > 0 ||
          this.quote.customer.state === 'OR' ||
          this.quote.customer.state === 'HI' ||
          this.quote.customer.state === 'AK' ||
          this.quote.customer.state === 'KY'
      );
    },
    isShowingUnderneathText() {
      return this.quote.singleClientProvidesMt25PercentRevenue === 'true'
        || this.quote.applicantExclusiveToAnyCompany === 'true'
        || this.quote.providesOtherServices === 'true'
        || this.quote.applicantOrAssociateProvidesOtherServices === 'true'
        || this.quote.enteredLimitedLiabilityContract === 'true'
        || this.quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true'
        || this.quote.isPreInspectionAgreementAlwaysSigned === 'false'
        || this.quote.applicantTakesDigitalPhotosOfInspections === 'false'
        || this.quote.isThereAMethodToAuthenticatePhotoDatetime === 'false'
        || this.quote.applicantTakesContinuingTrainingYearly === 'false'
        || this.quote.averageOfMoreThan3InspectionsPerDayPerInspector === 'true';
    },
    deductibleAmount() {
      return ((this.quote.homeInspectingExperience === '3-to-7'
        || this.quote.homeInspectingExperience === '3-to-7')
        && this.quote.knowledgeOfActEoPotentialClaimFuture === 'false'
        && this.quote.hasBeenSubjectToEoClaimPast === 'false'
        && this.quote.criticizedCensoredSuspendedRevoked === 'false'
        && this.quote.insuranceDeniedCancelledNonrenewedInsurance === 'false'
        && this.quote.preInspectionAgreementHasLimitationOfLiabilityClause === 'true'
        && this.$store.getters['homeInspector/totalRevenueOfInspectionsInThisYear'] <= 150000
        && Number(this.quote.homeInspectorsFullTime) + Number(this.quote.homeInspectorsPartTime) < 3);
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg,
          });
        }
      },
    },
  },

  methods: {
    next(routeName) {
      this.$router.push({
        name: routeName,
      });
    },

    navigateToPrev(route) {
      this.$router.push({
        name: route,
      });
    },
    calculatePremium(premium) {
      return premium + 59;
    },
    checkServices(service) {
      return this.quote.applicantOrAssociateReportMode.includes(service);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.state.pagefinalIsValid = true;
          return;
        }
        this.state.pagefinalIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
    },
    formSubmit() {
      this.loading = true;
      this.quote.status = STATUS.Submitted;
      this.quote.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('homeInspector/createFormalQuote');
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf('req') !== -1) {
          return 'This field is required';
        }
        return x.replace('_', ' ');
      }
    },
  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.presentation-container').offset().top,
    }, 500);
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,600&display=swap');

.container {
  background-color: white !important;
  padding-right: 0px;
  padding-left: 0px;
}
.img-call {
  height: 170px;
  max-height: 170px;
}
p {
  margin: 5px 0;
}
.strong {
  font-weight: bold !important;
}
table td {
  padding: 0 5px !important;
}
table > tbody > tr > td:first-child {
  width: 35%
}
table > tbody > tr > td:last-child {
  width: 65%
}


.table-bordered td {
  vertical-align: top;
  border-right: 2px solid #dee2e6;
  border-left-width: 0;
  border-bottom-width: 0;
  border-top-width: 0;
}
* {
  box-sizing: border-box;
}

/* Create three unequal columns that floats next to each other */
.column {
  float: center;
  padding: 10px;
  height: 300px; /* Should be removed. Only for demonstration */
}

.left {
  width: 25%;
}
.right {
  width: 5%;
}

.middle {
  width: 63%;
}

.comic-font{
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
}
.comic-font-bold{
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
}
.comic-font-extra-bold{
  font-family: 'Open Sans', sans-serif;
  font-weight:800;
}
.comic-font-semi-bold{
  font-family: 'Open Sans', sans-serif;
  font-weight:600;
}
hr.new1 {
  border-top: 1px solid grey;
}
.no-gutter > [class*='col-'] {
  padding-right:0;
  padding-left:0;
}
</style>
